import React from 'react';
import uslubiy from '../fayl/uslubiy_qollanma.pdf';

import { Button } from 'antd'
export const Uslubiy = () => {
  return (
    <div>
        <Button className='button'><a href={uslubiy}>Uslubiy qo'llanma</a></Button>
    </div>
  )
}
